let eventsData = [
  {
    id: "equal-trade-launch",
    title: "Equal Launch",
    isActive: true,
    validTill: "21/12/2022 12:00:00 PM",
    bodyText: "The Equal is now live!",
    buttons: [
      {
        text: "Read More",
        link: "https://docs.equalizer.exchange/",
      },
      {
        text: "Buy EQUAL",
        link: "/buy",
      },
      {
        text: "Mint",
        link: "buy_equity",
      },
      {
        text: "Trade Now",
        link: "/trade",
      },
    ],
  },
];
export default eventsData;
